var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-item',[_c('ion-label',{attrs:{"position":"stacked"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.field.label))+" ")]),_c('ion-input',{attrs:{"type":"text","value":_vm.model[_vm.field.userKey],"required":_vm.field.required},on:{"ionChange":function($event){return _vm.inputChanged($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }